import React from 'react';
import { Translate } from 'react-localize-redux';

export class MuchLove extends React.Component {
    render() {
        return (
            <Translate>
                {({ translate }) =>
                    <div
                        className={'icon-heart color-red'
                            + (this.props.doPadLeft ? ' pad-left-10' : '')
                            + (this.props.doUseTextLarge ? ' text-large' : ' text-medium')}
                        title={translate('much_love')}
                    />
                }
            </Translate>
        );
    }
}
